import React from 'react'
import { ProductsAppProvider } from '../context/ProductsContext'
import Products from './Products'

const ProductsHome = () => {
  return (
   <>
    <ProductsAppProvider>
        <Products/>
    </ProductsAppProvider>
   </>
  )
}

export default ProductsHome